import { gql } from 'apollo-boost';

export const READING_STATS_SCHOOL = gql`
    query readathonOverallStats(
        $itemsCounter: Int!
        $startFrom: String!
        $endOn: String!
    ) {
        readathonOverallStats(
            itemsCounter: $itemsCounter
            startFrom: $startFrom
            endOn: $endOn
        ) {
            id
            school {
                id
                avatarUrl
            }
            schoolName
            score
        }
    }
`;

export const READING_STATS_CLASS = gql`
query readathonStudentsClassOverallStats($itemsCounter: Int!, $startFrom: String!, $endOn: String!) {
    readathonStudentsClassOverallStats(itemsCounter: $itemsCounter, startFrom: $startFrom, endOn: $endOn) {
        id
        totalLogs
        studentsClass {
            id
            school {
                id
                name
            }
        }
        studentsClassName
    }
}
`;
